<template>
  <v-container fluid>
    <v-tabs class="mt-5" background-color="#f7f7f7">
      <v-tab to="/receptions">주행 접수 기록</v-tab>
      <v-tab link to="/deliveryReceptions">배송 접수 기록</v-tab>
    </v-tabs>
    <v-row align="center" class="ma-5">
      <v-col cols="12" sm="6">
        <v-row justify="start">
          <c-btn color="blue" outlined @click="prepareExcelData">데이터 다운로드</c-btn>
        </v-row>
      </v-col>
      <v-col cols="12" sm="6">
        <v-row justify="end" class="mr-3">
          <v-menu
            v-model="startMenu"
            :close-on-content-click="false"
            :nudge-right="40"
            offset-y
            transition="scale-transition"
          >
            <template v-slot:activator="{ on }">
              <div>
                <v-text-field
                  v-model="startDate"
                  label="조회일"
                  prepend-icon="event"
                  readonly
                  v-on="on"
                ></v-text-field>
              </div>
            </template>
            <c-date-picker v-model="startDate" @input="startMenu = false" firstDayOfWeek="1" :selectedDate="startDate" locale="ko-kr"></c-date-picker>
          </v-menu>
          <div>
            <v-text-field
              v-model="searchKeyword"
              label="예약자"
              prepend-icon="search"
              maxlength="32"
              @keypress.enter="searchByKeyword"
            ></v-text-field>
          </div>
          <div style="display: flex; align-items: center; margin-left: 10px">
            <v-btn color="blue" outlined small @click="searchByKeyword">검색</v-btn>
          </div>
        </v-row>
      </v-col>
    </v-row>
    <c-table 
      :headers="headers" 
      :items="filteredItems"
      :loading="loading"
    >
      <template #handicapInfo="{ item }">
        <div v-for="(handicapInfo, index) in item.handicapInfo" v-key="index">
          {{ handicapInfo }}
        </div>
      </template>
      <template #destination="{ item }">
        <div>
          <v-icon x-small color="light2Grey">place</v-icon>{{ item.departure }}
        </div>
        <template v-for="(wayPointRoute, index) in item.wayPointRoutes">
          <div :key="index">
            <v-icon x-small color="black">place</v-icon>{{ wayPointRoute.position }}
          </div>
        </template>
        <div>
          <v-icon x-small color="blue">place</v-icon>{{ item.destination }}
        </div>
      </template>
      <template #status.configName="{ item }">
        <c-reservation-state-chip
          :reservation="item"
          :reservation-state-event-flag="true"
          @onChangeReservationState="status => onChangeReservationState(item, status)"
          @onReReservation="onReReservation"
        />
      </template>
      <template #details="{ item }">
        <c-btn icon iconName="search" @click="linkToDetails(item)"></c-btn>
      </template>
    </c-table>
    <download-excel-dialog
      :open.sync="downloadExcelDialog"
      @reqDownloadExcel="reqDownloadExcel"
    />
    <v-overlay
        :value="loading"
    >
      <v-progress-circular
          indeterminate
          size="64"
      ></v-progress-circular>
    </v-overlay>
    <vue-excel-xlsx
        id="excelDownloadButton"
        ref="excelDownloadRef"
        :data="excelItems"
        :columns="excelColumns"
        :filename="excelFileName"
        sheetname="주행 접수 기록"
    />

    <!--자동배차 loading bar-->
    <v-dialog
        v-model="autoDialogOpen"
        hide-overlay
        persistent
        width="300"
    >
      <c-card
          class="blue"
      >
        <v-card-text>
          <div class="py-6 text-center white--text">
            자동 배차 중입니다.
          </div>
          <v-progress-linear
              indeterminate
              color="white"
              class="mb-0"
              height="10"
          ></v-progress-linear>
        </v-card-text>
      </c-card>
    </v-dialog>

    <!--수동배차 dialog-->
    <manual-reserve-dialog
        :open.sync="manualDialogOpen"
        :reservationCheckData.sync="reservationCheckData"
        :reservationFlag.sync="reservationFlag"
    ></manual-reserve-dialog>

    <time-recommend-dialog
        :open.sync="timeRecoDialogFlag"
        :reservation-id="autoReservationId"
        :fail-time="failTime"
        :available-time-list="availableTimeList"
        @reqAutoReservation="reqAutoReservation"
    />
  </v-container>
</template>
<script>
import DownloadExcelDialog from "../../Default/Common/DownloadExcelDialog";
import CReservationStateChip from "../../../components/CReservationStateChip";
import ManualReserveDialog from "../Reserve/ManualReserveDialog";
import TimeRecommendDialog from "../Reserve/TimeRecommendDialog";

export default {
  name: 'ReceptionsForDriving',
  components: {CReservationStateChip, DownloadExcelDialog, TimeRecommendDialog, ManualReserveDialog },
  data() {
    return {
      loading: false,
      headers: [
        { text: "번호", value: "idx", sortable: false, align: 'center', width: 70 },
        { text: "접수 일시", value: "created", sortable: true, align: 'center', width: 100 },
        { text: "출발 일시", value: "startDate", sortable: true, align: 'center', width: 100 },
        { text: "예약자", value: "customerName", sortable: true, align: 'center', width: 100 },
        { text: "회원 유형", value: "customerType", sortable: false, align: 'center', width: 120 },
        { text: "장애 유형 및 정도", value: "handicapInfo", sortable: false, align: 'center', width: 150 },
        { text: "휠체어", value: "wheelchair", sortable: false, align: 'center', width: 70 },
        { text: "수급자 여부", value: "isBasicLivelihood", sortable: false, align: 'center', width: 70 },
        { text: "예약 인원", value: "reservationCustomerCnt", sortable: false, align: 'center', width: 60 },
        { text: "탑승 인원", value: "riderCnt", sortable: false, align: 'center', width: 60 },
        { text: "보호자 수", value: "guardianCnt", sortable: false, align: 'center', width: 70 },
        { text: "담당 차량", value: "vehiclePlateNo", sortable: false, align: 'center', width: 100 },
        { text: "담당 기사", value: "driverName", sortable: false, align: 'center', width: 100 },
        { text: "편도/왕복", value: "wayType", sortable: false, align: 'center', width: 60 },
        { text: "시내/시외", value: "fareType", sortable: true, align: 'center', width: 60 },
        { text: "출발지/도착지", value: "destination", sortable: false, align: 'center', width: 200 },
        { text: "대기", value: "waitDuration", sortable: false, align: 'center', width: 70 },
        { text: "도움", value: "serviceDuration", sortable: false, align: 'center', width: 70 },
        { text: "진행상황", value: "status.configName", sortable: true, align: 'center', width: 120 },
        { text: "비고", value: "cancelComment", sortable: false, align: 'center', width: 100 },
        { text: "업데이트 일시", value: "updated", sortable: false, align: 'center', width: 120 },
        { text: "상세보기", value: "details", sortable: false, align: 'center', width: 80 },
      ],
      downloadExcelDialog: false,
      excelColumns: [
        { label: "번호", field: "idx" },
        { label: "접수 일시", field: "created" },
        { label: "출발 일시", field: "startDate" },
        { label: "예약자", field: "customerName" },
        { label: "회원 유형", field: "customerType" },
        { label: "장애 유형 및 정도", field: "handicapInfoExcel" },
        { label: "휠체어", field: "wheelchair" },
        { label: "수급자 여부", field: "isBasicLivelihood" },
        { label: "예약 인원", field: "reservationCustomerCnt" },
        { label: "탑승 인원", field: "riderCnt" },
        { label: "보호자 수", field: "guardianCnt" },
        { label: "담당 차량", field: "vehiclePlateNo" },
        { label: "담당 기사", field: "driverName" },
        { label: "편도/왕복", field: "wayType" },
        { label: "시내/시외", field: "fareType" },
        { label: "출발지", field: "departure" },
        { label: "경유지", field: "wayPointRoutesExcel" },
        { label: "도착지", field: "destination" },
        { label: "대기", field: "waitDuration" },
        { label: "도움", field: "serviceDuration" },
        { label: "진행상황", field: "statusExcel" },
        { label: "비고", field: "cancelComment" },
        { label: "업데이트 일시", field: "updated" },
      ],
      excelItems: [],
      items: [], // origin item list
      filteredItems: [], // display item list
      startMenu: false,

      // search
      startDate: this.$moment().format('YYYY-MM-DD'),
      searchKeyword: '',

      // 자동배차
      autoDialogOpen: false,
      autoReservationId: '',
      timeRecoDialogFlag: false,
      availableTimeList: [],
      failTime: '',

      // 수동배차
      manualDialogOpen: false,
      reservationInfo: [],
      reservationCheckData: {},
      reservationFlag: null,
    }
  },
  computed: {
    excelFileName() {
      return "주행 접수 기록_" + this.startDate;
    },
  },
  watch: {
    startDate() {
      this.reqGetReceptionList()
    },
    reservationFlag() {
      this.reqGetReceptionList();
      this.reservationFlag = false
    }
  },
  methods: {
    async reqGetReceptionList() {
      try {
        this.loading = true;
        const params = {
          date: this.startDate,
        }

        const defaultSort = (a,b) => a.created > b.created ? -1 : 1;
        const { data } = await this.$api.getReceptionListForDriving(params)
        this.items = data.sort(defaultSort).map(this.mappingItem)
        this.filteredItems = this.items
      } catch (err) {
        this.$store.commit("snackbar", { err, where: "reqGetReservationList" });
      } finally {
        this.loading = false;
      }
    },
    searchByKeyword() {
      this.filteredItems = this.items.filter(item => item.customerName.includes(this.searchKeyword))
    },
    async onReReservation(type, reservation) {
      const startTime = reservation.startTime;
      if (type === 'auto') {
        if (this.$moment(startTime).isBefore(this.$moment())) {
          return this.$store.commit('snackbar', {msg: '과거 시간은 자동배차가 불가능합니다.'});
        }
        await this.reqAutoReservation(reservation.reservationId, startTime);
      } else {
        await this.reqReservationWithPassengers(reservation.reservationId);
        this.manualDialogOpen = true;
      }
    },
    async reqAutoReservation(reservationId, startTime) {
      this.autoDialogOpen = true;

      let reqData = {
        reservationId: reservationId,
        startTime: startTime,
        centerId: this.$store.state.centerInfo.centerId
      };

      try {
        const { data } = await this.$api.autoReservation(reqData);
        const { isAssignSuccess, reservableList } = data;

        // 자동배차 실패 인 경우
        if(!isAssignSuccess) {
          // 가능한 시간이 없을 경우
          if (reservableList.length < 1) {
            this.$store.commit('alert',
                {
                  err: true, where: 'reqAutoReservation',
                  open: true, persistent: true,
                  msg: '배차 가능한 차량이 없습니다.\n' +
                      '예약시간을 확인해 주세요.'
                });
            this.autoDialogOpen = false;
            return;
          }

          // 가능한 시간 팝업
          this.autoDialogOpen = false;
          this.autoReservationId = reservationId;
          this.failTime = startTime;
          this.availableTimeList = reservableList.map(item => {
            let newItem = {};
            newItem.text = this.$moment(item.date).format('HH:mm');
            newItem.value = item.date;
            return newItem;
          });

          this.timeRecoDialogFlag = true;
        } else {
          this.autoDialogOpen = false;
          this.timeRecoDialogFlag = false;

          await this.reqGetReceptionList();
          this.$store.commit('snackbar', {color: 'blue', timeout: 2000, msg: '예약이 완료되었습니다.'});
        }
      } catch (err) {
        // 네트워크 에러일 때
        this.$store.commit('alert',
            {
              err, where: 'reqAutoReservation',
              open: true, persistent: true,
              msg: '자동배차에 실패했습니다.'
            });

        this.autoDialogOpen = false;
      }
    },
    async reqReservationWithPassengers(reservationId) {
      try {
        const { data } = await this.$api.getReservationWithPassengers(reservationId);
        this.reservationInfo = data.reservationList;
        this.reservationCheckData = data;
      } catch (err) {
        this.$store.commit('snackbar', {err, where: 'reqReservationWithPassengers'});
      }
    },
    async onChangeReservationState(item, status) {
      try {
        const reqData = {
          reservationId: item.reservationId,
          configString: status
        };

        if (status === 'rs_cancel' || status === 'rs_user_cancel') {
          await this.$api.updateCanceledReservation(reqData);
        } else {
          await this.$api.changeReservationState(reqData);
        }
      } catch (err) {
        this.$store.commit('snackbar', {err, where: 'reqUpdateCanceledReservation'});
      } finally {
        await this.reqGetReceptionList();
      }
    },
    async linkToDetails(item) {
      switch(item.status.configValue) {
        case 'rs_complete':
        case 'rs_receipt':
        case 'rs_progress':
        case 'rs_assign':
          await this.$router.push(`/reservation/${item.reservationId}`)
          break;
        case 'rs_driving':
        case 'rs_done':
          await this.$router.push(`/driveLog/${item.driveLogId}`)
          break;
        case 'rs_cancel':
        case 'rs_user_cancel':
          await this.$router.push(`canceledReservation/${item.reservationId}`)
          break;
        default:
          await this.$router.push(`/reservation/${item.reservationId}`)
          break;
      }
    },
    async prepareExcelData() {
      const { data } = await this.$api.getReceptionExcelData({ date: this.startDate })
      this.excelItems = data.receiptDriveList.map(this.mappingItem)
      this.downloadExcelDialog = true;
    },
    async reqDownloadExcel() {
      this.$refs.excelDownloadRef.exportExcel();
      this.downloadExcelDialog = false;
    },
    mappingItem(item, index) {
      return {
        ...item,
        created: this.$func.dateTimeToString(item.created),
        updated: this.$func.dateTimeToString(item.updated),
        idx: index + 1,
        customerType: item.customerType === '일반' ? item.customerType : `교통약자(${item.customerType})`,
        handicapInfo: item.handicapInfo ? JSON.parse(item.handicapInfo)
            .map(handicap => `${handicap.type} (${handicap.degree})`) : '-',
        wheelchair: item.wheelchair ? item.wheelchair : '-',
        isBasicLivelihood: item.isBasicLivelihood ? '예' : '아니요',
        wayType: '편도',
        fareType: item.fareType.startsWith('suburban') ? '시외' : '시내',
        riderCnt: item.riderCnt ? item.riderCnt : 0,
        guardianCnt: item.guardianCnt ? item.guardianCnt : 0,
        waitDuration: `${item.waitDuration ? this.displayDuration(item.waitDuration) : '-'}`,
        serviceDuration: `${item.serviceDuration ? this.displayDuration(item.serviceDuration) : '-'}`,
        handicapInfoExcel: item.handicapInfo ? JSON.parse(item.handicapInfo)
            .map(handicap => `${handicap.type} (${handicap.degree})`).join('\r\n') : '-',
        wayPointRoutesExcel: item.wayPointRoutes.map(route => route.position).join('\r\n'),
        statusExcel: item.status.configName
      }
    },
    displayDuration(sec) {
      let hours = Math.floor(sec / 3600);
      let minutes = Math.floor((sec - (hours * 3600)) / 60);
      let seconds = sec % 60;

      if (hours > 0) {
        return `${hours}시간 ${minutes}분 ${seconds}초`
      } else {
        return `${minutes}분 ${seconds}초`
      }
    },
  },
  activated() {
    this.reqGetReceptionList();
  },
};
</script>